import { ATUALIZAR_FILTROS, DESCARTAR_FILTROS } from '../actions/filtrosActions'
import { USER_AUTHENTICATED, USER_LOGOUT } from '../actions/authenticationJwtActions'
import { VISAO_POR_AUDITOR_AGRUPADOR } from '../actions/itensPorVisaoActions'
import { INFORMACOES_CONTEXTO_APLICACAO_RECUPERADAS } from '../actions/contextoAplicacaoActions'
import { getFiltroVisaoPorContextoAplicacao } from '../controllers/filtrosController'

export const OPCAO_RESP_TECNICA = 'Técnica'
export const OPCAO_RESP_POR_AGIR = 'Por agir'
export const OPCAO_RESP_TECNICA_NAO_RESP_AGIR = 'Em outras unidades'

export const RESPONSABILIDADE_UNIDADE_KEY = 'responsabilidadeUnidade'
export const CODIGO_USUARIO_KEY = 'codigoUsuario'

export const INITIAL_STATE = {
  visao: VISAO_POR_AUDITOR_AGRUPADOR,
  unidadesAtuais: {},
  [RESPONSABILIDADE_UNIDADE_KEY]: OPCAO_RESP_POR_AGIR,
  [CODIGO_USUARIO_KEY]: null
}

const validar = (filtros) => {
  const { visao } = filtros
  if (!visao) {
    throw new Error('visao não deve ser nula!')
  }
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ATUALIZAR_FILTROS: {
      const filtros = { ...state, ...action.payload }
      validar(filtros)
      return filtros
    }
    case DESCARTAR_FILTROS: {
      let filtros = { ...state }
      let filtrosKeys = action.payload
      filtrosKeys.forEach((filtroKey) => {
        filtros[filtroKey] = undefined
      })
      validar(filtros)
      return filtros
    }
    case INFORMACOES_CONTEXTO_APLICACAO_RECUPERADAS: {
      const { ignorarVisao } = action.payload
      let r = state
      if (!ignorarVisao) r = { ...r, ...getFiltroVisaoPorContextoAplicacao(action.payload) }
      return r
    }
    case USER_AUTHENTICATED:
      return {
        ...INITIAL_STATE,
        unidadesAtuais: state.unidadesAtuais,
        responsabilidadeUnidade: state.responsabilidadeUnidade
      }
    case USER_LOGOUT:
      return INITIAL_STATE
    default:
      return state
  }
}
